module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order_details":"Order details","order_details_text":"Control what you see when viewing your order list"},"id":{"order_details":"Detail Order","order_details_text":"Kontrol apa yang kamu lihat saat melihat daftar pesanan kamu"}}')
  delete Component.options._Ctor
}
